/// <reference path="../Bases/GridBase.ts" />
namespace _Ext {
    import fld = TabAurous.Purchase.PurchaseItemsRow.Fields;

    @Serenity.Decorators.registerClass([Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly])
    @Serenity.Decorators.editor()
    @Serenity.Decorators.element("<div/>")
    export class StockInItemGridEditor<TEntity> extends _Ext.GridBase<TEntity, any>
        implements Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly {

        protected get_ExtGridOptions(): ExtGridOptions { return Q.deepClone(q.DefaultEditorGridOptions); }

        protected getIdProperty() { return "__id"; }

        isChildGrid = true;

        protected nextId = 1;

        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public MarkUpPolicyId: number;
        public coef: number;

        public DeptId: number;
        public TransDate: Date;
        public TotalItems: number;
        public ProductTypeId: number;
        statement: string;
        //validate pieces and weight on new creation
        public pieces = [];
        public weight = [];
        public itemids = [];
        public isUpdate: number;
        public canUpdate: number;
        public GenSKU: boolean = false;
        public isEditable: boolean;

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({
                forceFitColumns: true, showFooterRow: false, rowHeight: 30, enableTextSelectionOnCells: true,
                selectedCellCssClass: "slick-row-selected"
            });
            this.slickGrid.onSort.subscribe((e, args) => {
                this.sortGridFunction((args.grid as Slick.Grid), args.sortCols[0], args.sortCols[0].sortCol.field);

                //(args.grid as Slick.Grid).init();
                (args.grid as Slick.Grid).invalidateAllRows();
                (args.grid as Slick.Grid).invalidate();
                (args.grid as Slick.Grid).render();
                (args.grid as Slick.Grid).resizeCanvas();
            });

        }

        private sortGridFunction(grid: Slick.Grid, column: any, field: any) {
            grid.getData().sort(function (a, b) {
                var result = a[field] > b[field] ? 1 :
                    a[field] < b[field] ? -1 :
                        0;
                return column.sortAsc ? result : -result;
            });
        }

        protected getQuickFilters() {
            return [];
        }

        protected id(entity: TEntity) {
            return (entity as any)[this.getIdProperty()];
        }

        protected save(opt: Serenity.ServiceOptions<any>, callback: (r: Serenity.ServiceResponse) => void) {
            var request = opt.request as Serenity.SaveRequest<TEntity>;
            var row = Q.deepClone(request.Entity);

            var id = this.id(row);
            if (id == null) {
                row[this.getIdProperty()] = "`" + this.nextId++;
            }

            if (!this.validateEntity(row, id)) {
                return;
            }

            var items = this.view.getItems().slice();
            if (id == null) {
                items.push(row);
            }
            else {
                var index = Q.indexOf(items, x => this.id(x) === id);
                items[index] = Q.deepClone({} as TEntity, items[index], row);
            }

            this.value = items;
            callback({});
        }

        protected deleteEntity(id: number) {
            this.view.deleteItem(id);
            setTimeout(() => {
                this.onItemsChanged();
                this.element.trigger('change');
                this.resetRowNumber();
            });
            return true;
        }

        protected validateEntity(row: TEntity, id: number) {
            return true;
        }

        protected getNewEntity(): TEntity {
            return {} as TEntity;
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [{
                title: this.getItemName(),
                cssClass: 'add-button',
                onClick: () => { this.addButtonClick() }
            }, Serenity.ColumnPickerDialog.createToolButton(this as any)];
        }

        protected addButtonClick(): void {
            this.createEntityDialog(this.getItemType(), dlg => {
                var dialog = dlg as StockInItemEditorDialog<TEntity>;
                dialog.parentEditor = this;
                dialog.onSave = (opt, callback) => this.save(opt, callback);
                dialog.loadEntityAndOpenDialog(this.getNewEntity());
            });
        }

        protected editItem(entityOrId: any): void {

            var id = entityOrId;
            var item = this.view.getItemById(id);
            this.createEntityDialog(this.getItemType(), dlg => {
                var dialog = dlg as ItemEditorDialog<TEntity>;
                dialog.onDelete = (opt, callback) => {
                    if (!this.deleteEntity(id)) {
                        return;
                    }
                    callback({});
                };
                //dialog.parentEditor = this;
                dialog.onSave = (opt, callback) => this.save(opt, callback);
                dialog.loadEntityAndOpenDialog(item);
            });
        }

        public getEditValue(property, target) {
            target[property.name] = this.value;
        }

        public setEditValue(source, property) {
            this.value = source[property.name];
        }

        public get value(): TEntity[] {
            var p = this.getIdProperty();

            (this.slickGrid as any).getEditController().commitCurrentEdit();

            let items = this.view.getItems();

            this.onBeforeGetValue(items);

            return items.map(x => {
                var y = Q.deepClone(x);
                var id = y[p];
                if (id && id.toString().charAt(0) == '`')
                    delete y[p];

                if (y['RowNum'])
                    delete y['RowNum'];
                return y;
            });
        }

        public set value(value: TEntity[]) {
            var id = this.getIdProperty();

            let val = value || [];

            let items = val.map(x => {
                var y = Q.deepClone(x);
                if ((y as any)[id] == null) {
                    (y as any)[id] = "`" + this.nextId++;
                }
                return y;
            });

            let r = this.onViewProcessData({ Entities: items })
            this.view.setItems(r.Entities, true);
            setTimeout(() => {
                this.onItemsChanged();
                this.element.trigger('change');
            });
            this.resetRowNumber(); // to generate serial no.
        }

        protected getGridCanLoad() {
            return false;
        }

        protected usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }

        private searchText: string;

        protected createToolbarExtensions(): void {
            Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text) => {
                this.searchText = Select2.util.stripDiacritics(Q.trimToNull(text) || '').toLowerCase();
                this.view.setItems(this.view.getItems(), true);
            });
        }

        protected onViewFilter(row): boolean {
            if (!super.onViewFilter(row)) {
                return false;
            }

            if (this.searchText) {
                return this.matchContains(row);
            }

            return true;
        }

        private matchContains(item): boolean {
            let result = false;

            for (let prop in item) {
                result = Select2.util.stripDiacritics(String(item[prop] || '')).toLowerCase().indexOf(this.searchText) >= 0;

                if (result == true) {
                    return result;
                }
            }

            return result;
        }

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        protected enableFiltering(): boolean { return false; }

        protected onViewSubmit() { return false; }

        get_readOnly(): boolean {
            return this.isReadOnly;
        }
        set_readOnly(value: boolean): void {
            this.isReadOnly = value;
            if (value == true) {
                this.element.find('.add-button').addClass('disabled');
                this.element.find('.stock-button').addClass('disabled');
                this.element.find('.approval-button').addClass('disabled');
                this.element.find('.order-button').addClass('disabled');
                let opt = this.slickGrid.getOptions();
                opt.editable = false;

                this.slickGrid.setOptions(opt);
            } else {
                this.element.find('.add-button').removeClass('disabled');
                this.element.find('.stock-button').removeClass('disabled');
                this.element.find('.approval-button').removeClass('disabled');
                this.element.find('.order-button').removeClass('disabled');
            }

        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.forceFitColumns = false;
            //opt.autoHeight = true; // If you need to show footer, you have to do opt.autoHeight = false
            return opt;
        }

        parentDialog: TransDialog<any, any>;

        //custom events
        onItemsChanged() {

        }
        onBeforeGetValue(items: TEntity[]) {

        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;

            let item = this.itemAt(row) as any;
            //To Set Master Product Image
            if (!Q.isEmptyOrNull(item.ImageName))
                this.parentDialog.Image = item.ImageName;

            let target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
            if (target.hasClass('edit')) {
                if (this.isReadOnly) {
                    target.addClass('readonly');
                    target.blur();
                    q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
                }
            }

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    if (this.isReadOnly) {
                        q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
                    }
                    else {
                        //TODO: Validate for TransItemID in RefTransItemID in Stock
                        q.information('Are you sure want to Delete?', '', true, () => {
                            let id = this.id(item);
                            let ref: TabAurous.Stock.StockItemRow[];
                            if (!Q.isEmptyOrNull(item.TransItemId))
                                TabAurous.Stock.StockItemService.GetStockTransactions({
                                    ProductId: item.ProductId,
                                    RefTransItemId: item.TransItemId,
                                    RefVoucherId: item.VoucherTypeId,
                                    RefTransId: item.TransId
                                }, response => ref == response.Entities,
                                    {
                                        async: false
                                    }
                                );

                            if (ref != null && ref.length > 0) {
                                q.Warning("Can not delete!", "This Item has been used in transactions Cannot Delete!");
                            } else {
                                this.view.deleteItem(id);
                                this.parentDialog.Image = "";
                            }
                        }, () => { });
                    }
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }

            if (target.hasClass('edit numeric')) {
                e.preventDefault();
                //TODO: Need to add System Parameter to enable disable blocking
                let input = $(e.target);
                if (input != undefined) {
                    if (this.isReadOnly) {
                        //Check Editable
                        target.addClass('readonly');
                        target.blur();
                        q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
                    }
                    else if (!this.isReadOnly) {
                        target.removeClass('readonly');
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101 && item.HasBom) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "UnitRate" && item.ItemTypeId == 101 && item.HasBom) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104 && item.CategoryId != "7") {
                            target.addClass('readonly');
                            target.blur();
                        }
                    }
                }
                this.view.refresh();
            }
        }

        private pendingChanges: Q.Dictionary<any> = {};

        protected inputsChange(e: JQueryEventObject,) {
            let cell = this.slickGrid.getCellFromEvent(e);
            let item = this.itemAt(cell.row) as any;
            let input = $(e.target);
            let field = input.data('field');
            let text = Q.coalesce(Q.trimToNull(input.val()), '0');
            let id = this.id(item);
            let pending = this.pendingChanges[id];
            let Locked: boolean = false;

            // *** Format Number ***
            let effective = this.getEffectiveValue(item, field);
            let oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                let i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 10) {
                q.Alert("Not Allowed", "Invalid Pieces", 2999, false);
                input.val(oldText);
                input.focus();
                return;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
                item.LaborDetails.forEach(function (labor) {
                    labor.Pieces = value;
                })
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    let labr = item.UnitLabour || 0;
                    let Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    let Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }
                item.LaborDetails.forEach(function (labor) {
                    labor.Pieces = value;
                })

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && !item.HasBom) {
                if (item.CalcOnId != 3) {
                    let labr = item.UnitLabour || 0;
                    let rate = item.UnitRate || 0;
                    if (item.ItemTypeId == 101 || item.ItemTypeId == 104) {
                        rate = item.UnitRate * item.Purity;
                        item.PureWeight = value * item.Purity;
                    }

                    let Net = (rate + labr) * value;
                    item.NetAmount = Net;
                    let Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

                if (item.LaborDetails != null)
                    item.LaborDetails.forEach(function (labor) {
                        labor.Weight = value;
                    })
            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    let labr = item.UnitLabour || 0;
                    let Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    let Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }


                if (item.CalcOnId == 3) {
                    let labr = item.UnitLabour || 0;
                    let Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    let Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }
                item[field] = value;
            }

            if (field === fld.UnitRate && item.ItemTypeId == 101 && item.HasBom == false) {
                if (item.CalcOnId != 3) {
                    let labr = item.UnitLabour || 0;
                    let Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    let Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }


                if (item.CalcOnId == 3) {
                    let labr = item.UnitLabour || 0;
                    let Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    let Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }
                item[field] = value;
            }




            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;
            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;
            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;
            }

            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;

            this.view.updateItem(id, item);

            this.view.refresh();
            (this.parentDialog as any).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => TabAurous.ColumnFormatter.numericInputFormatter(ctx, this);
            var amt = ctx => TabAurous.ColumnFormatter.AmountFormatter(ctx, this);
            var curr = new TabAurous.OMS.CurrencyFormatter;

            curr.currencyName = 'INR';

            var cur = ctx => curr.format(ctx);

            //var IsConsumed = this.ValidateStock();

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="LocId' + ctx.row + '" title="Location" />';
            };
            //Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(), this);

            Q.first(columns, x => x.field === fld.Pieces).format = ctx => {
                if (ctx.item.ItemTypeId != 104)
                    return this.isReadOnly == false ? TabAurous.ColumnFormatter.integerInputFormatter(ctx, this) : TabAurous.ColumnFormatter.ReadOnlyIntegerInput(ctx, this);
                else
                    return this.isReadOnly == false ? ctx.item.CategoryId != "7" ? TabAurous.ColumnFormatter.ReadOnlyIntegerInput(ctx, this) : TabAurous.ColumnFormatter.integerInputFormatter(ctx, this) : TabAurous.ColumnFormatter.ReadOnlyIntegerInput(ctx, this);
            }

            Q.first(columns, x => x.field === fld.Weight).format = ctx => {
                if (ctx.item.ItemTypeId == 101 && ctx.item.HasBom)
                    return TabAurous.ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
                else
                    return this.isReadOnly == false ? TabAurous.ColumnFormatter.WeightFormatter(ctx, this) : TabAurous.ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
            }

            Q.first(columns, x => x.field === fld.UnitRate).format = ctx => {
                if (ctx.item.ItemTypeId == 101 && ctx.item.HasBom)
                    return TabAurous.ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
                else
                    return this.isReadOnly == false ? TabAurous.ColumnFormatter.AmountFormatter(ctx, this) : TabAurous.ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
            }

            Q.first(columns, x => x.field === fld.Discount).format = ctx => {
                return this.isReadOnly == false ? TabAurous.ColumnFormatter.AmountFormatter(ctx, this) : TabAurous.ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
            }
            Q.first(columns, x => x.field === fld.DiscountPer).format = ctx => {
                return this.isReadOnly == false ? TabAurous.ColumnFormatter.numericInputFormatter(ctx, this) : TabAurous.ColumnFormatter.ReadonlynumericInputFormatter(ctx, this);
            }

            if (!this.GenSKU)
                columns = columns.filter(x => x.field != 'SKU');

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        private InlineLookup(RowIndex: string, Items: TabAurous.Purchase.PurchaseItemsRow[]) {

            var select = $("#LocId" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {

                let opt: Serenity.LookupEditorOptions = {
                    lookupKey: TabAurous.OMS.DepartmentMasterRow.lookupKey
                };
                var Editor = new TabAurous.InlineLookupEditor($("#LocId" + RowIndex), opt);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }

                Editor.value = Q.toId(Items[RowIndex].DepartmentId);
                Editor.changeSelect2(e => {
                    Items[RowIndex].DepartmentId = Q.toId(Editor.value);
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeAttr("readonly");
                }
            }
        }

    }
}